import Toast from "shared/toast";

export default function successToast(sourceNumber, destinationParams) {
  const numberName = sourceNumber.name;
  const { name, link } = destinationParams;

  return Toast.success({
    title: "Successfully moved Promo Number",
    message: `The PromoNumber ${numberName} has been moved to ${name}`,
    sticky: true,
    action: {
      text: "View Campaign",
      href: link,
      target: "_blank"
    }
  });
}
